export default __webpack_public_path__ + "static/media/mysubmission-24.36d39d30.jpeg";